import request, { post, get } from '@/utils/request'
import { ouchnCustom } from '../../service'

const urlGetUserInfo = ouchnCustom + '/web/ocFrontUser/selectUserByUserId'
const urlGetUserUnit = ouchnCustom + '/web/ocFrontUser/queryInstByUserId'
const urlUploadAvatar = ouchnCustom + '?'
const urlDeleteOldAvatar = ouchnCustom + '?'
const urlUpdatePhone = ouchnCustom + '/web/ocFrontUser/updatePhone'
const urlUpdateEmail = ouchnCustom + '/web/ocFrontUser/updateEmail'
const urlUpdateTrueName = ouchnCustom + '/web/ocFrontUser/updateTrueName'
const urlSendEmailCodeAndValidateUnique = ouchnCustom + '/web/ocFrontUser/sendEmailCodeAndValidateUnique'
const urlCalcleUser = ouchnCustom + '/web/ocFrontUser/calcleUser'
const urlCheckVerifyCode = ouchnCustom + '/web/ocFrontUser/check'
const urlGetNotificationList = ouchnCustom + '/web/myMessage/selectList'
const urlSetAllReaded = ouchnCustom + '/web/myMessage/updateList'
const updateUserAvatar = ouchnCustom + '/web/ocFrontUser/updateUserAvatar'
const selectInfo = ouchnCustom + '/web/myMessage/selectInfo'
const selectConfig = ouchnCustom + '/web/config/selectConfig'

// TODO:获取用户详细信息
export const apiGetUserInfo = () => get(urlGetUserInfo)

// 获取用户关联机构信息
export const apiGetUserUnit = () => get(urlGetUserUnit)

// 更新用户手机号
export const apiUpdatePhone = (data) => post(urlUpdatePhone, data)

// 更新用户邮箱
export const apiUpdateEmail = (data) => post(urlUpdateEmail, data)

// 更新用户昵称
export const apiUpdateTrueName = (data) => post(urlUpdateTrueName, data)

// 验证邮箱
export const apiVerifyEmail = (params) => get(urlSendEmailCodeAndValidateUnique, params)

// 注销用户
export const apiCalcleUser = (data) =>
  post(`${urlCalcleUser}?smsCode=${data.smsCode}&smsCodeKey=${data.smsCodeKey}&phoneNumber=${data.phoneNumber}`)

// 校验验证码
export const apiCheckVerifyCode = (data) => post(urlCheckVerifyCode, data)

export const apiUploadAvatar = () => post(urlUploadAvatar) //TODO暂时弃用

export const apiDeleteOldAvatar = () => post(urlDeleteOldAvatar) //TODO暂时弃用

// 消息通知列表
export const apiGetNotificationList = (params) => get(urlGetNotificationList, params)
export const apiSetAllReaded = (data) => post(urlSetAllReaded,data)
export const apiupdateUserAvatar = (params) => get(updateUserAvatar,params)
export const apiselectInfo = (params) => get(selectInfo, params)
export const apiselectConfig = (params) => get(selectConfig,params)
